import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'overview',
    templateUrl  : './overview.component.html',
    encapsulation: ViewEncapsulation.None
})
export class OverviewComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
